import { render, staticRenderFns } from "./backHome.vue?vue&type=template&id=d6588f76&scoped=true&"
import script from "./backHome.vue?vue&type=script&lang=js&"
export * from "./backHome.vue?vue&type=script&lang=js&"
import style0 from "./backHome.vue?vue&type=style&index=0&id=d6588f76&prod&lang=less&scoped=true&"
import style1 from "./backHome.vue?vue&type=style&index=1&id=d6588f76&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6588f76",
  null
  
)

export default component.exports